import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetalhesEmprestimoComponent } from './detalhes-emprestimo.component';
import { SharedModule } from '../../shared/shared.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { FuseConfirmDialogModule } from '@fuse/components';
import { RouterModule } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';


const routes = [
    {
      path: 'detalhesEmprestimo',
      component: DetalhesEmprestimoComponent
    }
  ];

@NgModule({
  declarations: [DetalhesEmprestimoComponent],
  imports: [
    SharedModule,
    CommonModule,
    FuseSharedModule,
    RouterModule.forChild(routes),
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTableModule,
    MatTabsModule,
    MatDividerModule,
    MatListModule,
    MatChipsModule,
    MatDialogModule,
    MatMenuModule,
    MatRippleModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule,
    NgxDnDModule,
    FuseConfirmDialogModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatCardModule,
    NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
   
  ], exports: [DetalhesEmprestimoComponent]
})
export class DetalhesEmprestimoModule { }
